import { OrderBox, RecipeItem } from '@library/api-user'
import { orderModel } from '../models/orderModel'

const useRecipeTiles = (recipes: RecipeItem[], box: OrderBox) => {
  const { getOrderRecipeImages } = orderModel()

  const maxRecipes = Number(box.numPortions) < 5 ? 5 : 3

  const recipeImages = getOrderRecipeImages(recipes, '200')
  const filledTiles = recipeImages.map((recipeImage, index) => ({
    ...recipeImage,
    quantity: recipes[index].quantity,
  }))

  const emptySlots = Math.max(0, maxRecipes - filledTiles.length)
  const placeholderTiles = Array.from({ length: emptySlots }, () => ({
    recipeId: null,
    imageUrl: null,
    quantity: null,
  }))

  return {
    recipes: [...filledTiles, ...placeholderTiles],
    maxRecipes,
  }
}

export { useRecipeTiles }
